import { makeActionCreator } from '../../../utilities'
import { RelationshipsAndGuarantorsConstants } from './relationshipsAndGuarantors.constants'

export const setRelationship = makeActionCreator(RelationshipsAndGuarantorsConstants.SET_RELATIONSHIP, 'relationship')
export const setNextOfKin = makeActionCreator(RelationshipsAndGuarantorsConstants.SET_NEXT_OF_KIN, 'nextOfKin')
export const setSameResidence = makeActionCreator(
  RelationshipsAndGuarantorsConstants.SET_SAME_RESIDENCE,
  'sameResidence'
)
export const setFirstName = makeActionCreator(RelationshipsAndGuarantorsConstants.SET_FIRST_NAME, 'firstName')
export const setMiddleInitial = makeActionCreator(
  RelationshipsAndGuarantorsConstants.SET_MIDDLE_INITIAL,
  'middleInitial'
)
export const setLastName = makeActionCreator(RelationshipsAndGuarantorsConstants.SET_LAST_NAME, 'lastName')
export const setSuffix = makeActionCreator(RelationshipsAndGuarantorsConstants.SET_SUFFIX, 'suffix')
export const setUnknownName = makeActionCreator(RelationshipsAndGuarantorsConstants.SET_UNKNOWN_NAME, 'unknownName')
export const setDOB = makeActionCreator(RelationshipsAndGuarantorsConstants.SET_DOB, 'dob')
export const setAge = makeActionCreator(RelationshipsAndGuarantorsConstants.SET_AGE, 'age')
export const setAgeUnit = makeActionCreator(RelationshipsAndGuarantorsConstants.SET_AGE_UNIT, 'ageUnit')
export const setSSN = makeActionCreator(RelationshipsAndGuarantorsConstants.SET_SSN, 'ssn')
export const setDriversLicense = makeActionCreator(
  RelationshipsAndGuarantorsConstants.SET_DRIVERS_LICENSE,
  'driversLicense'
)
export const setDriversLicenseState = makeActionCreator(
  RelationshipsAndGuarantorsConstants.SET_DRIVERS_LICENSE_STATE,
  'driversLicenseState'
)
export const setResponse = makeActionCreator(RelationshipsAndGuarantorsConstants.SET_RESPONSE, 'response')
export const setRelationshipsAndGuarantorsState = makeActionCreator(
  RelationshipsAndGuarantorsConstants.SET_RELATIONSHIPS_AND_GUARANTORS_STATE,
  'relationshipsAndGuarantors'
)
export const resetRelationshipsAndGuarantorsState = makeActionCreator(
  RelationshipsAndGuarantorsConstants.RESET_RELATIONSHIPS_AND_GUARANTORS_STATE
)
export const addRelationshipsAndGuarantors = makeActionCreator(
  RelationshipsAndGuarantorsConstants.ADD_RELATIONSHIPS_AND_GUARANTORS
)
export const clearRelationshipsAndGuarantorsData = makeActionCreator(
  RelationshipsAndGuarantorsConstants.CLEAR_RELATIONSHIPS_AND_GUARANTORS_DATA
)
export const setRelationshipsAndGuarantorsList = makeActionCreator(
  RelationshipsAndGuarantorsConstants.SET_RELATIONSHIPS_AND_GUARANTORS_LIST,
  'relationshipsAndGuarantorsList'
)
export const setRelationshipsAndGuarantorsData = makeActionCreator(
  RelationshipsAndGuarantorsConstants.SET_RELATIONSHIPS_AND_GUARANTORS_DATA,
  'relationshipsAndGuarantorsData'
)
export const removeRelationshipsAndGuarantors = makeActionCreator(
  RelationshipsAndGuarantorsConstants.REMOVE_RELATIONSHIPS_AND_GUARANTORS,
  'selectedRelationshipsAndGuarantorsKey'
)

export const saveRelationshipsAndGuarantors = makeActionCreator(RelationshipsAndGuarantorsConstants.SAVE_STATE)
